module.exports = __webpack_public_path__ + "img/officer.bd322a93.svg";